import { ReportJSON } from '@aloft/toolkit-shared';

import { createNodeWithText } from './utils.ts';

// TODO: ask product whether this needs to be adjusted to support 1004C & 1025 too.
export function generateTotalXmlAnnotationNodes(
  doc: XMLDocument,
  comp: ReportJSON['comps'][string],
): HTMLElement[] {
  const annotationNodes = [];

  annotationNodes.push(
    createNodeWithText(doc, 'AD_ADDR1', comp.salesGridData.annotations.PropertyStreetAddress),
  );
  annotationNodes.push(
    createNodeWithText(
      doc,
      'AD_ADDR2',
      `${comp.salesGridData.annotations.PropertyCity}, ${comp.salesGridData.annotations.PropertyState} ${comp.salesGridData.annotations.PropertyPostalCode}`,
    ),
  );

  annotationNodes.push(
    createNodeWithText(doc, 'SF_GLA', comp.salesGridData.annotations.GrossLivingArea),
  );

  annotationNodes.push(
    createNodeWithText(doc, 'SC_SOURCE1', comp.salesGridData.annotations.DataSourceDescription),
  );
  annotationNodes.push(
    createNodeWithText(doc, 'FN_CONC1', comp.salesGridData.annotations.SalesConcessions),
  );
  annotationNodes.push(
    createNodeWithText(doc, 'FN_CONC2', comp.salesGridData.annotations.FinancingConcessions),
  );
  annotationNodes.push(
    createNodeWithText(doc, 'DT_SALTIM1', comp.salesGridData.annotations.DateOfSale),
  );
  annotationNodes.push(
    createNodeWithText(doc, 'LC_LOCAT1', comp.salesGridData.annotations.Location),
  );
  annotationNodes.push(
    createNodeWithText(doc, 'ST_SITSIZE', comp.salesGridData.annotations.SiteArea),
  );
  annotationNodes.push(createNodeWithText(doc, 'ST_SITEVW', comp.salesGridData.annotations.View));
  annotationNodes.push(
    createNodeWithText(doc, 'DA_CONSTQL', comp.salesGridData.annotations.Quality),
  );
  annotationNodes.push(createNodeWithText(doc, 'AG_AGYRBLT', comp.salesGridData.annotations.Age));
  annotationNodes.push(
    createNodeWithText(doc, 'AG_COND1', comp.salesGridData.annotations.Condition),
  );
  annotationNodes.push(
    createNodeWithText(doc, 'RM_BATH', comp.salesGridData.annotations.TotalBathroomCount),
  );
  annotationNodes.push(
    createNodeWithText(doc, 'BM_BSM1', comp.salesGridData.annotations.BasementArea),
  );
  annotationNodes.push(
    createNodeWithText(doc, 'BM_BSM2', comp.salesGridData.annotations.BasementFinish),
  );
  annotationNodes.push(
    createNodeWithText(doc, 'FU_FUNCTUT', comp.salesGridData.annotations.FunctionalUtility),
  );
  annotationNodes.push(
    createNodeWithText(doc, 'CR_GARPRK1', comp.salesGridData.annotations.CarStorage),
  );
  annotationNodes.push(
    createNodeWithText(doc, 'PF_PORPAT1', comp.salesGridData.annotations.PorchDeck),
  );
  annotationNodes.push(
    createNodeWithText(doc, 'BL_BLANK1', comp.salesGridData.annotations.OtherFeature1),
  );

  return annotationNodes;
}
